import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { GrStack } from "../layout";
import { palette, semanticChartColors } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import classNames from "classnames";
import { Cell, Pie, PieChart, Tooltip } from "recharts";
import { GrTypography } from "../inputs/GrTypography";
const colorScales = Object.values(semanticChartColors);
export function GrPieChart(props) {
    const { variant = "pie", radius: radius = 100, className, blendStroke } = props;
    return (_jsx("div", { className: classNames("GrPieChart", className), children: props.alternativeText ? (_jsx(GrStack, { flexDirection: "row", justifyContent: "center", alignItems: "center", width: props.canvasWidth, height: props.canvasHeight, flexWrap: "nowrap", children: _jsx(GrTypography, { type: "Visual.EN.Body04", children: props.alternativeText }) })) : (_jsxs(StyledChart, { width: props.canvasWidth, height: props.canvasHeight, data: props.data, children: [_jsx(Tooltip, {}), _jsx(Pie, { dataKey: "value", nameKey: "label", cx: "50%", cy: "50%", data: props.data, outerRadius: radius, innerRadius: variant === "donut" ? radius * 0.3 : undefined, blendStroke: blendStroke, children: props.data.map((x, i) => (_jsx(Cell, { fill: x.color ? palette[x.color] : colorScales === null || colorScales === void 0 ? void 0 : colorScales[i % colorScales.length], style: { outline: "none" } }, i))) })] })) }));
}
const StyledChart = styled(PieChart)(() => {
    return {
        fontFamily: typography["Visual.EN.Header01"].fontFamily,
        ".recharts-tooltip-item": {
            ...typography["Content.Body04"],
        },
    };
});
//# sourceMappingURL=GrPieChart.js.map